import { createFileRoute, redirect } from '@tanstack/react-router'
import { Trans, useLingui } from '@lingui/react/macro'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { TAKE_A_BREAK_TITLES } from '@/features/take-a-break/types'
import { AccessControlsConfirmation } from '../_app/your-play.access-controls/-confirmation/access-controls-confirmation'
import { getPlayerSession } from '@/features/player-session'

const searchSchema = z.object({
  validTo: z.string().datetime(),
  type: z.enum([
    'H24',
    'H48',
    'D3',
    'D7',
    'D14',
    'D30',
    'D90',
    'TEST_1_MIN',
    'TEST_5_MIN',
  ]),
})

export const Route = createFileRoute('/take-a-break-confirmation')({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
  beforeLoad: async () => {
    const playerSession = await getPlayerSession()

    if (playerSession.isUserLoggedIn) {
      return redirect({ to: '/' })
    }
  },
})

function RouteComponent() {
  const { i18n, t } = useLingui()
  const { type, validTo } = Route.useSearch()
  const date = i18n.date(validTo, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })

  return (
    <AccessControlsConfirmation
      heading={<Trans>You have successfully set a Take a Break</Trans>}
      description={
        <Trans>
          Your{' '}
          {{
            period: t(TAKE_A_BREAK_TITLES[type]),
          }}{' '}
          Take a Break has started and will end on {date}
        </Trans>
      }
    />
  )
}
